var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-box mt-3"},[_c('div',{staticClass:"small text-uppercase text-muted mb-1"},[_vm._v("What happens")]),_c('ul',{staticClass:"mb-0"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }